(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4280],{

/***/ 46676:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var BUTTER_CLIENT_VERSION = '1.2.5';

var axios = __webpack_require__(9669);

var resources = {
  Post: __webpack_require__(60445),
  Category: __webpack_require__(8402),
  Tag: __webpack_require__(9210),
  Author: __webpack_require__(8306),
  Feed: __webpack_require__(1863),
  Content: __webpack_require__(5986),
  Page: __webpack_require__(16288)
}

function Butter(apiToken, testMode, timeout, axiosHook) {
  if (!(this instanceof Butter)) {
    return new Butter(apiToken, testMode, timeout, axiosHook);
  }

  if (!apiToken) {
    throw 'ButterCMS API token not set';
  }

  // Use live mode by default
  var testMode = testMode || false;

  // 3000ms timeout by default
  var timeout = timeout || 3000;

  var requestMethods = this._prepMethods(apiToken, testMode, timeout, axiosHook);

  this._prepResources(requestMethods);
}

Butter.prototype = {
  _prepResources: function(requestMethods) {
    for (var name in resources) {
      this[
        name[0].toLowerCase() + name.substring(1)
      ] = new resources[name](requestMethods);
    }
  },
  _prepMethods: function(apiToken, testMode, timeout, axiosHook) {
    return {
      get: function(url, params) {
        var headers = {'X-Butter-Client': 'JS/' + BUTTER_CLIENT_VERSION}
        // detect if library is called in server side
        if (typeof window === 'undefined'){
          headers['Accept-Encoding'] = 'gzip'
        }
        var conn = axios.create({
          baseURL: 'https://api.buttercms.com/v2',
          timeout: timeout,
          headers: headers
        });

        if (axiosHook) {
          axiosHook(conn)
        }

        var params = params || {};

        // Add api token to query string
        params.auth_token = apiToken;

        // Append &test=1&preview=1 query strings
        if (testMode) {
          params.test = 1
          params.preview = 1
        }

        return conn.get(url, {params: params})
      }
    }
  }
}

module.exports = Butter;


/***/ }),

/***/ 8306:
/***/ (function(module) {

"use strict";


function Author(conn) {
  this._conn = conn;
}

Author.prototype = {
  list: function(options) {
    return this._conn.get('authors/', options)
  },
  retrieve: function(slug, options) {
    return this._conn.get('authors/'+slug+'/', options)
  }
}

module.exports = Author;


/***/ }),

/***/ 8402:
/***/ (function(module) {

"use strict";


function Category(conn) {
  this._conn = conn;
}

Category.prototype = {
  list: function(options) {
    return this._conn.get('categories/', options)
  },
  retrieve: function(slug, options) {
    return this._conn.get('categories/'+slug+'/', options)
  }
}

module.exports = Category;


/***/ }),

/***/ 5986:
/***/ (function(module) {

"use strict";


function Content(conn) {
  this._conn = conn;
}

Content.prototype = {
  retrieve: function(keys, options) {
    var keys = keys || [];
    var options = options || {};
    var params = Object.assign({keys: keys.join()}, options);

    return this._conn.get('content/', params)
  }
}

module.exports = Content;


/***/ }),

/***/ 1863:
/***/ (function(module) {

"use strict";


function Feed(conn) {
  this._conn = conn;
}

Feed.prototype = {
  retrieve: function(type, options) {
    return this._conn.get('feeds/'+type+'/', options)
  }
}

module.exports = Feed;


/***/ }),

/***/ 16288:
/***/ (function(module) {

"use strict";


function Page(conn) {
  this._conn = conn;
}

Page.prototype = {
  list: function(page_type, options) {
    return this._conn.get('pages/'+page_type+'/', options)
  },
  retrieve: function(page_type, page_slug, options) {
    return this._conn.get('pages/'+page_type+'/'+page_slug+'/', options)
  },
  search: function(query, options) {
    var options = options || {};
    options.query = query || '';

    return this._conn.get('pages/search/', options)
  }
}

module.exports = Page;

/***/ }),

/***/ 60445:
/***/ (function(module) {

"use strict";


function Post(conn) {
  this._conn = conn;
}

Post.prototype = {
  list: function(options) {
    return this._conn.get('posts/', options)
  },
  retrieve: function(slug, options) {
    return this._conn.get('posts/'+slug+'/', options)
  },
  search: function(query, options) {
    var options = options || {};
    options.query = query || '';

    return this._conn.get('posts/search/', options)
  }
}

module.exports = Post;


/***/ }),

/***/ 9210:
/***/ (function(module) {

"use strict";


function Tag(conn) {
  this._conn = conn;
}

Tag.prototype = {
  list: function(options) {
    return this._conn.get('tags/', options)
  },
  retrieve: function(slug, options) {
    return this._conn.get('tags/'+slug+'/', options)
  }
}

module.exports = Tag;


/***/ }),

/***/ 95160:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Testimonial.ced62c92.png","height":460,"width":480,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAV1BMVEURFBd8gYaUmqKGjpU8PkLI0NdeYGMsIyK9x84fHiDP197Y4OaxusJscnqOl6GEV0pzd3y1v8dNNSpmanDm7vUyPUmDeXqtpac+MyxIUltWR0V+X1yrf3NZlvnUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQUlEQVR4nAXBBwLAIAgEsFNAwNm9///OJkiJAfiCEKbEDkeMFFZVYLZKrBdgktt+P4pctsPbNyBSTuV3wEwq9R5/SKUCZJmYbxoAAAAASUVORK5CYII="});

/***/ }),

/***/ 30223:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Testimonial1.0f60859c.png","height":460,"width":480,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAe1BMVEXEqI7urWR2fYDQs5R1gonfmEvYkELLwK2dq6TP0sN2bWuGe3W9s6CFaFd9dXK0qJdibW2LmJl+jZJSUVM0OENrcneatLDqpVKbqKKVoaLkrnSafWqlnZByVVDYqX9POTmXin08LTKfi4GXeGuKXFZ6Yl5TXWIWGCNjd312rNSUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAASUlEQVR4nAXBhwKAEAAFwFcIIbO9d///hd3heQOtpRDIkw9Udg3u5HxezhpfdP14XCviQpTl1Q6TDdZu1YmizQjXU4mCMXAY9QOjpwQdeydA3AAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 40358:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Testimonial2.cb003145.png","height":460,"width":480,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAb1BMVEU2QEl8hpDd4+l/kJcYHyPN3+yqwtIBCQ+fsb4pMDVjf49NW2VcYWhgbHiKeneQmJ6blZZ9aGYaJjNvi5AwNz6KoLCMorJjWl7Exc2ns766rrBLUVpRUFaam6MPGSOqs7d0bnCtxMJINjJLZm+yx8GXcGqhAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQ0lEQVR4nAXBgwHAQAAEsHvbtbX/jE3Q7vRwoEP7cjGOGFjmI8cy4q315CpPMMppdWgJj3CpVUjYUOI2iwGMpJ1S3f+CxAN8evNNvAAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 22365:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Testimonial3.ad474258.png","height":460,"width":480,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAWlBMVEW/2NXU4ddHV1lqc3u50tORiJHAxsLJ4dqKhIezwseTqq1adH+VoqpSbHJ6kZqswcGdr61xh481T1jG2dWzsrGjrLC5z8p6eHalm5ZLaWyKjpKZgYSVm56wmpzwgMuiAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQ0lEQVR4nAXBBQKAMAwEsBuTtnPF+f83SaC9IUIRBLMDBhFbjuLcfMGHvh9eCvZUahB9sFx9dZNhUwutDMF2pd6zrB9aSwLbWoXnHwAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 63997:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Testimonial4.d3f782e2.png","height":460,"width":480,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAdVBMVEUbKzqpm5CbeG2MiIXKrpUnOEdNUVXY3tve6uk3OkHa4+JESEzA1tSsyNBafo2z0t2rsayjsrfK0tJxXlrDrZawrqXT2dPY2tLQzsHK4OL18eyjytefz954h42IfXFKbHui0uB7scF9aVpVaXRoZWYtLTSyqqHBFHIbAAAACXBIWXMAAAsTAAALEwEAmpwYAAAARklEQVR4nAXBhQGAMAADsM6NGcPd/z+RBG2jtKrTB8a7UbNiQHmv1UNfSDJM9i4GwqTKzjlDYK1qHyOEgyP+WIDtkmfYww+B2QPBoyIzwQAAAABJRU5ErkJggg=="});

/***/ }),

/***/ 42848:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/koalafi-logo-1.1566232e.png","height":460,"width":443,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAFVBMVEX///+wwMzE09zU5OjK2N73+fq/5PFCbGPLAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAHUlEQVR4nGNgwAOYWZiZWZhYGRjYmBgZGUEMnAAABjYAK6aIYWcAAAAASUVORK5CYII="});

/***/ }),

/***/ 18391:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/momnt-logo-1.574fcdc8.png","height":460,"width":480,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAHlBMVEX////9/v7Hz9iotMLT2N/Xyczt2NeZqLm3ws+2vcr3gVs8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKklEQVR4nGWKuREAIBCE2L1H7b9hIzWQjAE4SEjSdfDoigiTs8vL+dI3bwvrAFSrPaUWAAAAAElFTkSuQmCC"});

/***/ }),

/***/ 25504:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k8": function() { return /* reexport */ CtaLinkButton; },
  "Qj": function() { return /* reexport */ LinkButton; }
});

// UNUSED EXPORTS: Button

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/landingPage/views/assets/Demyst.svg
var assets_Demyst = __webpack_require__(65966);
;// CONCATENATED MODULE: ./src/landingPage/components/Button/Button.jsx







var Button = function(_param) {
    var _autoWidth = _param.autoWidth, autoWidth = _autoWidth === void 0 ? false : _autoWidth, _demystIcon = _param.demystIcon, demystIcon = _demystIcon === void 0 ? false : _demystIcon, hidden = _param.hidden, onClick = _param.onClick, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = _param.size, size = _size === void 0 ? "lg" : _size, disabled = _param.disabled, type = _param.type, children = _param.children, className = _param.className, _noStyle = _param.noStyle, noStyle = _noStyle === void 0 ? false : _noStyle, props = _object_without_properties(_param, [
        "autoWidth",
        "demystIcon",
        "hidden",
        "onClick",
        "variant",
        "size",
        "disabled",
        "type",
        "children",
        "className",
        "noStyle"
    ]);
    var classesArray = [
        "Button",
        styles.Button,
        variant === "inverted" && styles.Inverted,
        variant === "secondary" && styles.Secondary,
        variant === "secondary-alt" && styles.Secondary_alt,
        hidden && styles.Hidden,
        autoWidth === true && styles.AutoWidth,
        size === "hero" && styles.Size_lg,
        size === "lg" && styles.Size_lg,
        size === "md" && styles.Size_md,
        size === "sm" && styles.Size_sm,
        disabled && styles.Disabled,
        className, 
    ];
    var classes = noStyle !== true ? clsx(classesArray) : className;
    return /*#__PURE__*/ _jsxs("button", _object_spread_props(_object_spread({
        type: type,
        className: classes,
        onClick: function(e) {
            onClick && onClick(e);
        }
    }, props), {
        children: [
            noStyle !== true ? /*#__PURE__*/ _jsx("span", {
                children: children
            }) : children,
            demystIcon && /*#__PURE__*/ _jsx("img", {
                src: Demyst.src,
                alt: "",
                width: "16",
                height: "22",
                loading: "eager"
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/landingPage/components/Button/Button.module.less
var Button_module = __webpack_require__(62225);
var Button_module_default = /*#__PURE__*/__webpack_require__.n(Button_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/landingPage/components/Button/LinkButton.jsx








var LinkButton = function(_param) {
    var _autoWidth = _param.autoWidth, autoWidth = _autoWidth === void 0 ? false : _autoWidth, _demystIcon = _param.demystIcon, demystIcon = _demystIcon === void 0 ? false : _demystIcon, hidden = _param.hidden, isExternal = _param.isExternal, onClick = _param.onClick, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = _param.size, size = _size === void 0 ? "lg" : _size, disabled = _param.disabled, to = _param.to, children = _param.children, className = _param.className, _noStyle = _param.noStyle, noStyle = _noStyle === void 0 ? false : _noStyle, _bookDemoButtonLandingPage = _param.bookDemoButtonLandingPage, bookDemoButtonLandingPage = _bookDemoButtonLandingPage === void 0 ? false : _bookDemoButtonLandingPage, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "autoWidth",
        "demystIcon",
        "hidden",
        "isExternal",
        "onClick",
        "variant",
        "size",
        "disabled",
        "to",
        "children",
        "className",
        "noStyle",
        "bookDemoButtonLandingPage"
    ]);
    var classesArray = [
        "Button",
        (Button_module_default()).LinkButton,
        variant === "inverted" && (Button_module_default()).Inverted,
        variant === "text" && (Button_module_default()).Text,
        variant === "secondary" && (Button_module_default()).Secondary,
        variant === "secondary-alt" && (Button_module_default()).Secondary_alt,
        hidden && (Button_module_default()).Hidden,
        autoWidth === true && (Button_module_default()).AutoWidth,
        size === "hero" && (Button_module_default()).Size_lg,
        size === "lg" && (Button_module_default()).Size_lg,
        size === "md" && (Button_module_default()).Size_md,
        size === "sm" && (Button_module_default()).Size_sm,
        disabled && (Button_module_default()).Disabled,
        bookDemoButtonLandingPage && (Button_module_default()).BookDemoButton,
        className, 
    ];
    var classes = noStyle !== true ? (0,clsx_m/* default */.Z)(classesArray) : className;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        href: to,
        className: classes,
        onClick: function(e) {
            onClick && onClick(e);
        },
        isExternal: isExternal
    }, props), {
        children: [
            noStyle !== true ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: children
            }) : children,
            demystIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                src: assets_Demyst/* default.src */.Z.src,
                alt: "",
                width: "16",
                height: "22",
                loading: "eager"
            })
        ]
    }));
};

// EXTERNAL MODULE: ./src/config/userTracking.js
var userTracking = __webpack_require__(67474);
// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
;// CONCATENATED MODULE: ./src/landingPage/components/Button/CtaLinkButton.jsx








var CtaLinkButton = function(_param) {
    var className = _param.className, _autoWidth = _param.autoWidth, autoWidth = _autoWidth === void 0 ? true : _autoWidth, text = _param.text, classNameDiv = _param.classNameDiv, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "className",
        "autoWidth",
        "text",
        "classNameDiv"
    ]);
    var sendCtaGaEvent = function() {
        (0,userTracking/* sendGaEvent */.k8)({
            action: "CTA Click - Request A Demo",
            category: "Main CTA",
            label: "/app/contact"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "".concat((Button_module_default()).CtaLinkButtonContainer, " ").concat(classNameDiv),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkButton, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            demystIcon: true,
            autoWidth: autoWidth,
            variant: "secondary",
            onClick: sendCtaGaEvent,
            href: linksConstants/* linksConstants.REQUEST_DEMO */.s.REQUEST_DEMO,
            className: className
        }, props), {
            children: text || "Request a demo"
        }))
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Button/index.jsx





/***/ }),

/***/ 16717:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "VM": function() { return /* reexport */ Hero; },
  "Zx": function() { return /* reexport */ HeroCol; },
  "RV": function() { return /* reexport */ HeroSubtitle; },
  "LR": function() { return /* reexport */ HeroTitle; }
});

// UNUSED EXPORTS: HeroBadges, HeroColWrapper, HeroImage, HeroImageWrapper, HeroParagraph, HeroVideo

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/landingPage/components/Hero/Hero.module.less
var Hero_module = __webpack_require__(51979);
var Hero_module_default = /*#__PURE__*/__webpack_require__.n(Hero_module);
;// CONCATENATED MODULE: ./src/landingPage/components/Hero/Hero.jsx



var Hero = function(param) {
    var id = param.id, className = param.className, _background = param.background, background = _background === void 0 ? "violet-900" : _background, _type = param.type, type = _type === void 0 ? "one-col" : _type, _doubledPadding = param.doubledPadding, doubledPadding = _doubledPadding === void 0 ? false : _doubledPadding, removeTopPadding = param.removeTopPadding, removeBottomPadding = param.removeBottomPadding, _withStarsAnimation = param.withStarsAnimation, withStarsAnimation = _withStarsAnimation === void 0 ? false : _withStarsAnimation, children = param.children;
    var backgroundClassName = typeof background === "string" ? background.replace(/-/g, "_").toLowerCase() : typeof background === "object" ? background.map(function(bg) {
        return bg.replace(/-/g, "_").toLowerCase();
    }).join("_to_") : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (0,clsx_m/* default */.Z)((Hero_module_default()).Hero, (Hero_module_default())[backgroundClassName], (type === "two-col" || type === "two-col-form") && (Hero_module_default()).TypeTwoCol, type === "two-col-form" && (Hero_module_default()).TypeTwoColForm, type === "two-col-text" && (Hero_module_default()).TypeTwoColText, doubledPadding && (Hero_module_default()).DoubledPadding, removeTopPadding && (Hero_module_default()).RemoveTopPadding, removeBottomPadding && (Hero_module_default()).RemoveBottomPadding, className),
        id: id,
        children: [
            withStarsAnimation && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Hero_module_default()).HeroStars,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Hero_module_default()).HeroStars1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Hero_module_default()).HeroStars2
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Hero_module_default()).HeroStars3
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Hero_module_default()).HeroContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Hero_module_default()).HeroColWrapper,
                    children: children
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Hero/HeroBadges.jsx


var HeroBadges = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.HeroBadges,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Hero/HeroCol.jsx


var HeroCol = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Hero_module_default()).HeroCol,
        children: children
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Hero/HeroColWrapper.jsx


var HeroColWrapper = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.HeroColWrapper,
        children: children
    });
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./src/platform/utils/useViewport.js + 1 modules
var utils_useViewport = __webpack_require__(72573);
;// CONCATENATED MODULE: ./src/landingPage/components/Hero/HeroImage.jsx







var HeroImage = function(_param) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, className = _param.className, tabletSrc = _param.tabletSrc, mobileSrc = _param.mobileSrc, props = _object_without_properties(_param, [
        "src",
        "alt",
        "className",
        "tabletSrc",
        "mobileSrc"
    ]);
    var ref = useViewport(), desktop = ref.desktop, tablet = ref.tablet, mobile = ref.mobile;
    var deviceSpecificProps = _object_spread({}, desktop && {
        priority: true,
        src: src
    }, tablet && tabletSrc && {
        src: tabletSrc
    }, mobile && mobileSrc && {
        src: mobileSrc
    });
    return /*#__PURE__*/ _jsx("div", {
        className: clsx(styles.HeroImage, className),
        children: /*#__PURE__*/ _jsx(Image, _object_spread({
            src: src,
            alt: alt
        }, deviceSpecificProps, props))
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Hero/HeroImageWrapper.jsx



var HeroImageWrapper = function(param) {
    var className = param.className, children = param.children;
    return /*#__PURE__*/ _jsx("div", {
        className: clsx(styles.HeroImageWrapper, className),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Hero/HeroSubtitle.jsx



var HeroSubtitle = function(param) {
    var _noMarginBottom = param.noMarginBottom, noMarginBottom = _noMarginBottom === void 0 ? false : _noMarginBottom, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: (0,clsx_m/* default */.Z)((Hero_module_default()).HeroSubtitle, className, noMarginBottom && (Hero_module_default()).NoMarginBottom),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Hero/HeroTitle.jsx



var HeroTitle = function(param) {
    var _multiLine = param.multiLine, multiLine = _multiLine === void 0 ? false : _multiLine, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
        className: (0,clsx_m/* default */.Z)((Hero_module_default()).HeroTitle, multiLine && (Hero_module_default()).MultiLine),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Hero/HeroParagraph.jsx



var HeroParagraph = function(param) {
    var className = param.className, type = param.type, children = param.children;
    return /*#__PURE__*/ _jsx("p", {
        className: clsx(styles.HeroParagraph, type === "subheading" && styles.HeroSubheading, className),
        children: children
    });
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/framer-motion.es.js
var framer_motion_es = __webpack_require__(6805);
// EXTERNAL MODULE: ./src/config/appConfig.js
var appConfig = __webpack_require__(84762);
// EXTERNAL MODULE: ./src/config/userTracking.js
var userTracking = __webpack_require__(67474);
;// CONCATENATED MODULE: ./src/landingPage/components/Hero/HeroVideo.jsx












var HeroVideo = function(param) {
    var src = param.src, image = param.image, mobileImage = param.mobileImage, className = param.className;
    var ref = useState(false), videoMounted = ref[0], setVideoMounted = ref[1];
    var ref1 = useRef(null);
    var ref2 = useViewport(), desktop = ref2.desktop, mobile = ref2.mobile;
    var deviceSpecificProps = _object_spread({}, desktop && {
        priority: true,
        src: image
    }, mobile && mobileImage && {
        src: mobileImage
    });
    var mountVideo = function() {
        sendGaEvent({
            action: "Click to watch video",
            category: "Video",
            label: "Watch homepage video"
        });
        ref1.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "nearest"
        });
        setVideoMounted(true);
    };
    /* eslint-disable jsx-a11y/media-has-caption */ return /*#__PURE__*/ _jsxs("div", {
        ref: ref1,
        className: clsx(styles.HeroVideo, className),
        children: [
            !videoMounted && /*#__PURE__*/ _jsxs("div", {
                className: styles.HeroVideoPlaceholder,
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.HeroVideoPlaceholderImage,
                        children: /*#__PURE__*/ _jsx(Image, _object_spread_props(_object_spread({
                            width: "958",
                            height: "534",
                            src: image,
                            layout: "responsive",
                            priority: false
                        }, deviceSpecificProps), {
                            alt: ""
                        }))
                    }),
                    /*#__PURE__*/ _jsxs("button", {
                        "aria-label": "Play video",
                        onClick: mountVideo,
                        children: [
                            /*#__PURE__*/ _jsx(FiPlay, {}),
                            /*#__PURE__*/ _jsx("span", {
                                children: "Play Video"
                            })
                        ]
                    })
                ]
            }),
            src && videoMounted && /*#__PURE__*/ _jsx(AnimatePresence, {
                children: /*#__PURE__*/ _jsx(motion.div, _object_spread_props(_object_spread({}, animatePresenceConfig), {
                    children: /*#__PURE__*/ _jsx("video", {
                        autoPlay: true,
                        className: styles.HeroVideoPlayer,
                        src: src,
                        controls: true,
                        controlsList: "nodownload noremoteplayback"
                    })
                }))
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Hero/index.jsx












/***/ }),

/***/ 1699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$0": function() { return /* reexport */ Section; },
  "Ze": function() { return /* reexport */ SectionBigNumber; },
  "JZ": function() { return /* reexport */ SectionCol; },
  "OT": function() { return /* reexport */ SectionHeading_SectionHeading; },
  "Pi": function() { return /* reexport */ SectionImage; },
  "Xn": function() { return /* reexport */ SectionList; },
  "PS": function() { return /* reexport */ SectionListItem; },
  "Lo": function() { return /* reexport */ SectionParagraph_SectionParagraph; },
  "NZ": function() { return /* reexport */ SectionTitle; }
});

// UNUSED EXPORTS: SectionBlogThumbnails, SectionButtonGrid, SectionCallout, SectionDataGrid, SectionLinkButton, SectionTestimonials, SectionWebinarThumbnails

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/landingPage/components/Section/Section.module.less
var Section_module = __webpack_require__(81144);
var Section_module_default = /*#__PURE__*/__webpack_require__.n(Section_module);
// EXTERNAL MODULE: ./src/landingPage/components/Button/index.jsx + 3 modules
var Button = __webpack_require__(25504);
;// CONCATENATED MODULE: ./src/landingPage/components/Section/Section.jsx




var Section = function(param) {
    var id = param.id, _type = param.type, type = _type === void 0 ? "one-col" : _type, _reverse = param.reverse, reverse = _reverse === void 0 ? false : _reverse, _overrideColumnReversal = param.overrideColumnReversal, overrideColumnReversal = _overrideColumnReversal === void 0 ? false : _overrideColumnReversal, _reverseMobile = param.reverseMobile, reverseMobile = _reverseMobile === void 0 ? false : _reverseMobile, _doubledPadding = param.doubledPadding, doubledPadding = _doubledPadding === void 0 ? false : _doubledPadding, _removeTopPadding = param.removeTopPadding, removeTopPadding = _removeTopPadding === void 0 ? false : _removeTopPadding, _removeBottomPadding = param.removeBottomPadding, removeBottomPadding = _removeBottomPadding === void 0 ? false : _removeBottomPadding, _colWidthsEqual = param.colWidthsEqual, colWidthsEqual = _colWidthsEqual === void 0 ? false : _colWidthsEqual, _overlayHero = param.overlayHero, overlayHero = _overlayHero === void 0 ? false : _overlayHero, _background = param.background, background = _background === void 0 ? "white" : _background, masthead = param.masthead, className = param.className, children = param.children, _classSectionWrapper = param.classSectionWrapper, classSectionWrapper = _classSectionWrapper === void 0 ? false : _classSectionWrapper;
    var ref, ref1, ref2, ref3;
    var backgroundClassName = typeof background === "string" ? background.replace(/-/g, "_").toLowerCase() : typeof background === "object" ? background.map(function(bg) {
        return bg.replace(/-/g, "_").toLowerCase();
    }).join("_to_") : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: id,
        className: (0,clsx_m/* default */.Z)((Section_module_default()).Section, (Section_module_default())[backgroundClassName], doubledPadding && (Section_module_default()).DoubledPadding, removeTopPadding && (Section_module_default()).RemoveTopPadding, removeBottomPadding && (Section_module_default()).RemoveBottomPadding, type === "one-col" && (Section_module_default()).TypeOneCol, type === "two-col" && (Section_module_default()).TypeTwoCol, type === "three-col" && (Section_module_default()).TypeThreeCol, reverse && (Section_module_default()).Reverse, reverseMobile && (Section_module_default()).ReverseMobile, overrideColumnReversal && (Section_module_default()).OverrideReversal, colWidthsEqual && (Section_module_default()).ColWidthsEqual, overlayHero && (Section_module_default()).OverlayHero, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Section_module_default()).SectionContainer,
            children: [
                masthead && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Section_module_default()).SectionMasthead,
                    children: [
                        (masthead === null || masthead === void 0 ? void 0 : masthead.title) && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: (Section_module_default()).SectionTitle,
                            children: masthead.title
                        }),
                        (masthead === null || masthead === void 0 ? void 0 : masthead.subtitle) && (typeof (masthead === null || masthead === void 0 ? void 0 : masthead.subtitle) === "object" ? masthead === null || masthead === void 0 ? void 0 : masthead.subtitle.map(function(subtitle) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: (Section_module_default()).SectionSubtitle,
                                children: subtitle
                            }, subtitle);
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: (Section_module_default()).SectionSubtitle,
                            children: masthead.subtitle
                        })),
                        (masthead === null || masthead === void 0 ? void 0 : masthead.linkButton) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* LinkButton */.Qj, {
                            autoWidth: masthead === null || masthead === void 0 ? void 0 : (ref = masthead.linkButton) === null || ref === void 0 ? void 0 : ref.autoWidth,
                            variant: masthead === null || masthead === void 0 ? void 0 : (ref1 = masthead.linkButton) === null || ref1 === void 0 ? void 0 : ref1.variant,
                            href: masthead === null || masthead === void 0 ? void 0 : (ref2 = masthead.linkButton) === null || ref2 === void 0 ? void 0 : ref2.to,
                            children: masthead === null || masthead === void 0 ? void 0 : (ref3 = masthead.linkButton) === null || ref3 === void 0 ? void 0 : ref3.label
                        }),
                        (masthead === null || masthead === void 0 ? void 0 : masthead.ctaButton) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* CtaLinkButton */.k8, {
                            autoWidth: true
                        })
                    ]
                }),
                children && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx_m/* default */.Z)((Section_module_default()).SectionColWrapper, reverse && (Section_module_default()).Reverse, classSectionWrapper),
                    children: children
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/landingPage/utils/butter-client.js
var butter_client = __webpack_require__(55894);
// EXTERNAL MODULE: ./src/constants/linksConstants.js
var constants_linksConstants = __webpack_require__(71571);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/landingPage/components/subcomponents/ResourceCard.jsx







var ResourceCard_ResourceCard = function(param) {
    var image = param.image, title = param.title, summary = param.summary, authorImage = param.authorImage, authorName = param.authorName, published = param.published, href = param.href, _type = param.type, type = _type === void 0 ? "default" : _type, className = param.className;
    return /*#__PURE__*/ _jsx(LinkButton, {
        className: clsx(styles.ResourceCard, type === "alternate" && styles.Alternate, type === "webinar" && styles.Webinar, className),
        noStyle: true,
        href: href,
        children: /*#__PURE__*/ _jsxs("article", {
            children: [
                image && /*#__PURE__*/ _jsx("div", {
                    className: styles.ResourceCardImage,
                    children: /*#__PURE__*/ _jsx(Image, {
                        src: image,
                        alt: "",
                        layout: "fill",
                        unoptimized: true
                    })
                }),
                type == "webinar" && /*#__PURE__*/ _jsx("div", {
                    className: styles.ResourceCardWebinarImage,
                    children: /*#__PURE__*/ _jsx(FiTv, {})
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: styles.ResourceCardContent,
                    children: [
                        /*#__PURE__*/ _jsx(SectionHeading, {
                            children: title
                        }),
                        /*#__PURE__*/ _jsx(SectionParagraph, {
                            children: summary
                        })
                    ]
                }),
                type === "default" && /*#__PURE__*/ _jsxs("div", {
                    className: styles.ResourceCardAuthor,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: styles.ResourceCardAuthorAvatar,
                            children: authorImage && /*#__PURE__*/ _jsx(Image, {
                                priority: false,
                                src: authorImage,
                                alt: "",
                                title: authorName,
                                loading: "lazy",
                                width: "40",
                                height: "40"
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: styles.ResourceCardAuthorName,
                                    children: authorName
                                }),
                                /*#__PURE__*/ _jsx("span", {
                                    className: styles.ResourceCardDate,
                                    children: published
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }, title);
};

;// CONCATENATED MODULE: ./src/landingPage/components/Section/SectionBlogThumbnails.jsx









var SectionBlogThumbnails = function(param) {
    var _type = param.type, type = _type === void 0 ? "default" : _type, posts = param.posts, _defaultPageSize = param.defaultPageSize, defaultPageSize = _defaultPageSize === void 0 ? 3 : _defaultPageSize;
    var ref = useState([]), thumbs = ref[0], setThumbs = ref[1];
    useEffect(function() {
        if (!posts) {
            butter.post.list({
                page: 1,
                page_size: defaultPageSize
            }).then(function(response) {
                var data = response.data.data;
                setThumbs(data);
            });
        }
    }, []);
    useEffect(function() {
        if (posts) {
            var getSpecificPosts = function() {
                var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee() {
                    var specificPosts;
                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return Promise.all(posts.map(function() {
                                    var _ref = _async_to_generator(regeneratorRuntime.mark(function _callee(p) {
                                        var ref, data;
                                        return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    _ctx.next = 2;
                                                    return butter.post.retrieve(p);
                                                case 2:
                                                    ref = _ctx.sent;
                                                    data = ref.data.data;
                                                    return _ctx.abrupt("return", data);
                                                case 5:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee);
                                    }));
                                    return function(p) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()));
                            case 2:
                                specificPosts = _ctx.sent;
                                setThumbs(specificPosts);
                            case 4:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
                return function getSpecificPosts() {
                    return _ref.apply(this, arguments);
                };
            }();
            getSpecificPosts();
        }
    }, [
        posts
    ]);
    if (!thumbs) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: clsx(styles.SectionBlogThumbnails, type === "alternate" && styles.SectionBlogThumbnailsAlternate),
        children: thumbs === null || thumbs === void 0 ? void 0 : thumbs.map(function(param) {
            var featured_image = param.featured_image, title = param.title, summary = param.summary, author = param.author, slug = param.slug;
            return /*#__PURE__*/ _jsx(ResourceCard, {
                type: type,
                href: linksConstants.BLOGPOST.replace(":id", slug),
                image: featured_image,
                title: title,
                summary: summary,
                authorImage: author.profile_image,
                authorName: "".concat(author.first_name, " ").concat(author.last_name)
            }, title);
        })
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Section/SectionButtonGrid.jsx






var SectionButtonGrid_Button = function(param) {
    var icon = param.icon, name = param.name, text = param.text, href = param.href, color = param.color, type = param.type;
    var colorClassName = color === null || color === void 0 ? void 0 : color.replace(/-/g, "_").toLowerCase();
    var nameClassName = name === null || name === void 0 ? void 0 : name.replace(/ /g, "");
    if (!href) return /*#__PURE__*/ _jsx(Btn, {
        className: clsx(styles.SectionButtonGridButton, styles[nameClassName], styles[colorClassName]),
        noStyle: true,
        children: /*#__PURE__*/ _jsxs("span", {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.SectionButtonGridButtonIcon,
                    children: /*#__PURE__*/ _jsx(Image, {
                        src: icon,
                        alt: name,
                        width: "64",
                        height: "64",
                        layout: "responsive",
                        priority: false
                    })
                }),
                type === "use-cases" ? /*#__PURE__*/ _jsxs("div", {
                    className: styles.SectionButtonGridContent,
                    children: [
                        name && /*#__PURE__*/ _jsx(SectionHeading, {
                            children: name
                        }),
                        text && /*#__PURE__*/ _jsx(SectionParagraph, {
                            children: text
                        })
                    ]
                }) : type === "data-providers" || type === "pages" ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        name && /*#__PURE__*/ _jsx(SectionHeading, {
                            children: name
                        }),
                        text && /*#__PURE__*/ _jsx(SectionParagraph, {
                            children: text
                        }),
                        href && /*#__PURE__*/ _jsx("span", {
                            className: styles.SectionButtonGridButtonLabel,
                            children: type === "data-providers" ? "View In Catalog" : "Learn More"
                        })
                    ]
                }) : null
            ]
        })
    });
    return /*#__PURE__*/ _jsx(LinkButton, {
        className: clsx(styles.SectionButtonGridButton, styles[nameClassName], styles[colorClassName]),
        href: href,
        noStyle: true,
        children: /*#__PURE__*/ _jsxs("span", {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.SectionButtonGridButtonIcon,
                    children: /*#__PURE__*/ _jsx(Image, {
                        src: icon,
                        alt: name,
                        width: "64",
                        height: "64",
                        layout: "responsive",
                        priority: false
                    })
                }),
                type === "use-cases" ? /*#__PURE__*/ _jsxs("div", {
                    className: styles.SectionButtonGridContent,
                    children: [
                        name && /*#__PURE__*/ _jsx(SectionHeading, {
                            children: name
                        }),
                        text && /*#__PURE__*/ _jsx(SectionParagraph, {
                            children: text
                        })
                    ]
                }) : type === "data-providers" || type === "pages" ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        name && /*#__PURE__*/ _jsx(SectionHeading, {
                            children: name
                        }),
                        text && /*#__PURE__*/ _jsx(SectionParagraph, {
                            children: text
                        }),
                        href && /*#__PURE__*/ _jsx("span", {
                            className: styles.SectionButtonGridButtonLabel,
                            children: type === "data-providers" ? "View In Catalog" : "Learn More"
                        })
                    ]
                }) : null
            ]
        })
    });
};
var SectionButtonGrid = function(param) {
    var buttons = param.buttons, _gridSize = param.gridSize, gridSize = _gridSize === void 0 ? 8 : _gridSize, _type = param.type, type = _type === void 0 ? "data-providers" : _type, _color = param.color, color = _color === void 0 ? "white" : _color, className = param.className;
    if (!buttons) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.SectionButtonGridWrapper,
        children: /*#__PURE__*/ _jsx("div", {
            className: clsx(styles.SectionButtonGrid, gridSize === 4 && styles.GridSizeFour, gridSize === 2 && styles.GridSizeTwo, type === "use-cases" && styles.UseCases, type === "data-providers-small" && styles.DataProviders, className),
            children: buttons === null || buttons === void 0 ? void 0 : buttons.map(function(b, i) {
                return /*#__PURE__*/ _jsx(SectionButtonGrid_Button, {
                    icon: b.icon,
                    name: b.name,
                    href: b.href ? b.href : null,
                    text: b.text,
                    color: color,
                    type: type
                }, i);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Section/SectionDataGrid.jsx




var DataItem = function(param) {
    var name = param.name, text = param.text;
    return /*#__PURE__*/ _jsx("div", {
        className: clsx(styles.SectionButtonGridButton),
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.SectionButtonGridContent,
            children: [
                name && /*#__PURE__*/ _jsx(SectionHeading, {
                    children: name
                }),
                text && /*#__PURE__*/ _jsx(SectionParagraph, {
                    children: text
                })
            ]
        })
    });
};
var SectionDataGrid = function(param) {
    var data = param.data, _gridSize = param.gridSize, gridSize = _gridSize === void 0 ? 8 : _gridSize, className = param.className;
    if (!data) return null;
    return /*#__PURE__*/ _jsx("div", {
        className: styles.SectionButtonGridWrapper,
        children: /*#__PURE__*/ _jsx("div", {
            className: clsx(styles.SectionButtonGrid, gridSize === 4 && styles.GridSizeFour, gridSize === 2 && styles.GridSizeTwo, className),
            children: data === null || data === void 0 ? void 0 : data.map(function(b, i) {
                return /*#__PURE__*/ _jsx(DataItem, {
                    name: b.name,
                    text: b.text
                }, i);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Section/SectionCallout.jsx



var SectionCallout = function(param) {
    var _background = param.background, background = _background === void 0 ? "violet-1000" : _background, children = param.children;
    var backgroundClassName = background === null || background === void 0 ? void 0 : background.replace(/-/g, "_").toLowerCase();
    return /*#__PURE__*/ _jsx("div", {
        className: clsx(styles.SectionCallout, styles[backgroundClassName]),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Section/SectionCol.jsx



var SectionCol = function(param) {
    var className = param.className, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((Section_module_default()).SectionCol, className),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Section/SectionHeading.jsx



var SectionHeading_SectionHeading = function(param) {
    var className = param.className, children = param.children, _type = param.type, type = _type === void 0 ? "h3" : _type, _asParagraph = param.asParagraph, asParagraph = _asParagraph === void 0 ? false : _asParagraph;
    if (!asParagraph) {
        if (type === "h2") return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
            className: (0,clsx_m/* default */.Z)((Section_module_default()).SectionHeading, className),
            children: children
        });
        if (type === "h3") return /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
            className: (0,clsx_m/* default */.Z)((Section_module_default()).SectionHeading, className),
            children: children
        });
        if (type === "h4") return /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
            className: (0,clsx_m/* default */.Z)((Section_module_default()).SectionHeading, className),
            children: children
        });
        if (type === "h5") return /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
            className: (0,clsx_m/* default */.Z)((Section_module_default()).SectionHeading, className),
            children: children
        });
        if (type === "h6") return /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
            className: (0,clsx_m/* default */.Z)((Section_module_default()).SectionHeading, className),
            children: children
        });
        if (type === "p") return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            className: (0,clsx_m/* default */.Z)((Section_module_default()).SectionHeading, className),
            children: children
        });
        if (type === "span") return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: (0,clsx_m/* default */.Z)((Section_module_default()).SectionHeading, className),
            children: children
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: (0,clsx_m/* default */.Z)((Section_module_default()).SectionHeading, (Section_module_default())[type], className),
        children: children
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var src_object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/platform/utils/useViewport.js + 1 modules
var utils_useViewport = __webpack_require__(72573);
;// CONCATENATED MODULE: ./src/landingPage/components/Section/SectionImage.jsx







var SectionImage = function(_param) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, className = _param.className, tabletSrc = _param.tabletSrc, mobileSrc = _param.mobileSrc, layout = _param.layout, props = (0,src_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt",
        "className",
        "tabletSrc",
        "mobileSrc",
        "layout"
    ]);
    var ref = (0,utils_useViewport/* useViewport */.S)(), desktop = ref.desktop, tablet = ref.tablet, mobile = ref.mobile;
    var deviceSpecificProps = (0,src_object_spread/* default */.Z)({}, desktop && {
        priority: true,
        src: src
    }, tablet && tabletSrc && {
        src: tabletSrc
    }, mobile && mobileSrc && {
        src: mobileSrc
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((Section_module_default()).SectionImage, layout === "responsive" && (Section_module_default()).Responsive, className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,src_object_spread/* default */.Z)({
            src: src,
            alt: alt,
            layout: layout,
            priority: false
        }, deviceSpecificProps, props))
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Section/SectionLinkButton.jsx






var SectionLinkButton = function(_param) {
    var to = _param.to, _size = _param.size, size = _size === void 0 ? "md" : _size, _variant = _param.variant, variant = _variant === void 0 ? "text" : _variant, children = _param.children, rest = _object_without_properties(_param, [
        "to",
        "size",
        "variant",
        "children"
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.SectionDataGridButtonWrapper,
        children: /*#__PURE__*/ _jsx(LinkButton, _object_spread_props(_object_spread({
            to: to,
            size: size,
            variant: variant,
            autoWidth: true
        }, rest), {
            children: children
        }))
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Section/SectionList.jsx



var SectionList = function(param) {
    var className = param.className, children = param.children, _size = param.size, size = _size === void 0 ? "md" : _size, background = param.background;
    var backgroundClassName = background === null || background === void 0 ? void 0 : background.replace(/-/g, "_").toLowerCase();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (0,clsx_m/* default */.Z)((Section_module_default()).SectionList, size === "sm" && (Section_module_default()).SectionListSmall, background && (Section_module_default()).SectionListCard, background && (Section_module_default())[backgroundClassName], className),
        children: children
    });
};

// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
;// CONCATENATED MODULE: ./src/landingPage/components/Section/SectionListItem.jsx




var SectionListItem = function(param) {
    var icon = param.icon, className = param.className, children = param.children;
    var iconToShow = icon ? typeof icon === "function" ? icon() : typeof icon === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: icon,
        alt: ""
    }) : null : typeof icon === "object" ? icon : /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiCheck */.UgA, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: (0,clsx_m/* default */.Z)((Section_module_default()).SectionListItem, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Section_module_default()).SectionListItemIcon,
                children: iconToShow
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Section_module_default()).SectionListItemContent,
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Section/SectionParagraph.jsx



var SectionParagraph_SectionParagraph = function(param) {
    var className = param.className, type = param.type, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
        className: (0,clsx_m/* default */.Z)((Section_module_default()).SectionParagraph, type === "subheading" && (Section_module_default()).SectionSubheading, className),
        children: children
    });
};

// EXTERNAL MODULE: ./src/landingPage/views/assets/images/Testimonial.png
var Testimonial = __webpack_require__(95160);
// EXTERNAL MODULE: ./src/landingPage/views/assets/images/Testimonial1.png
var Testimonial1 = __webpack_require__(30223);
// EXTERNAL MODULE: ./src/landingPage/views/assets/images/Testimonial2.png
var Testimonial2 = __webpack_require__(40358);
// EXTERNAL MODULE: ./src/landingPage/views/assets/images/Testimonial3.png
var Testimonial3 = __webpack_require__(22365);
// EXTERNAL MODULE: ./src/landingPage/views/assets/images/Testimonial4.png
var Testimonial4 = __webpack_require__(63997);
// EXTERNAL MODULE: ./src/landingPage/views/assets/images/momnt-logo-1.png
var momnt_logo_1 = __webpack_require__(18391);
// EXTERNAL MODULE: ./src/landingPage/views/assets/images/koalafi-logo-1.png
var koalafi_logo_1 = __webpack_require__(42848);
;// CONCATENATED MODULE: ./src/landingPage/components/Section/SectionTestimonials.jsx















var testimonials = [
    [
        {
            quote: "We wouldn't have been as good at what we are doing had we not had a partner like Demyst that can flip on data, data partners and data channels effectively overnight, and advise us on the other data channels and data partners we should be looking at for our benefit. Time to market with a partner like Demyst was and is crucial for our success, especially our early success.",
            role: "Chief Technology Officer",
            source: "Brian Lanehart",
            color: "coolGray-200",
            image: momnt_logo_1/* default */.Z
        },
        {
            quote: "Leveraging a single API to maintain external data relationships has simplified and accelerated our fraud prevention and credit processes supporting business growth into new geographies.",
            role: "Director of Engineering",
            source: "Leading Global Payments and Shopping Service",
            color: "blue-300",
            image: Testimonial/* default */.Z
        },
        {
            quote: "There's a lot of simplicity to doing a one-time integration versus a bunch of independent integrations.",
            role: "Senior Vice President of Fraud",
            source: "David Hicks",
            color: "coolGray-100",
            image: koalafi_logo_1/* default */.Z
        }, 
    ],
    [
        {
            quote: "As a startup, there's no way we could've gotten to market with a beta product in six months, without someone like Demyst.",
            role: "Chief Technology Officer",
            source: "Brian Lanehart",
            color: "blue-200",
            image: momnt_logo_1/* default */.Z
        },
        {
            quote: "Given the complexity and the number of teams involved and integrations this implementation has gone extremely well, which is a testament to the testing planning and preparation.",
            role: "Senior Program Manager",
            source: "Tier 1 Australian Bank",
            color: "coolGray-200",
            image: Testimonial2/* default */.Z
        },
        {
            quote: "You’ve exceeded my expectations.",
            role: "Head of Risk",
            source: "Leading Asia Pacific cashback platform",
            color: "blue-300",
            image: Testimonial3/* default */.Z
        }, 
    ],
    [
        {
            quote: "It's also important in a partner like Demyst because they know the industry because they understand your business and your use case.",
            role: "Senior Vice President of Fraud",
            source: "David Hicks",
            color: "coolGray-100",
            image: koalafi_logo_1/* default */.Z
        },
        {
            quote: "This sophisticated new technology is deeply integrated with client's existing platforms to provide our customers with a quick, simple and secure experience.",
            role: "Group Executive",
            source: "Tier 1 Australian Bank",
            color: "blue-200",
            image: Testimonial4/* default */.Z
        },
        {
            quote: "Thank you for a great year and getting our project live. Appreciate your patience, hard work as well as resilience in getting us to a very good position ahead of our pilot activation.",
            role: "Senior Delivery Manager",
            source: "Tier 1 Australian Bank",
            color: "coolGray-100",
            image: Testimonial1/* default */.Z
        }, 
    ], 
];
var SectionTestimonials = function(param) {
    var _duration = param.duration, duration = _duration === void 0 ? 10000 : _duration;
    // it's all hardcoded here because why not
    var ref = useState(0), index = ref[0], setIndex = ref[1];
    var viewport = useViewport();
    var getNextIndex = function(currentIndex) {
        var index = currentIndex + 1;
        return index < testimonials.length ? index : 0;
    };
    var getPrevIndex = function(currentIndex) {
        var index = currentIndex - 1;
        return index >= 0 ? index : testimonials.length - 1;
    };
    useEffect(function() {
        if (viewport.desktop_small_min) {
            var timeout = setTimeout(function() {
                setIndex(getNextIndex(index));
            }, duration);
            return function() {
                return clearTimeout(timeout);
            };
        }
    }, [
        index
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.Container,
                children: /*#__PURE__*/ _jsx("div", {
                    className: clsx(styles.Wrapper),
                    children: testimonials[index].map(function(param) {
                        var quote = param.quote, role = param.role, source = param.source, image = param.image;
                        return /*#__PURE__*/ _jsx("div", {
                            className: styles.Card,
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: styles.Content,
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: styles.Stars,
                                        children: [
                                            /*#__PURE__*/ _jsx(FiStar, {}),
                                            /*#__PURE__*/ _jsx(FiStar, {}),
                                            /*#__PURE__*/ _jsx(FiStar, {}),
                                            /*#__PURE__*/ _jsx(FiStar, {}),
                                            /*#__PURE__*/ _jsx(FiStar, {})
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs(SectionHeading, {
                                        type: "h4",
                                        asParagraph: true,
                                        className: styles.Quote,
                                        children: [
                                            "“",
                                            quote,
                                            "”"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: styles.Attribution,
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: styles.ImageWrapper,
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    className: styles.Image,
                                                    children: /*#__PURE__*/ _jsx(Image, {
                                                        src: image,
                                                        alt: "",
                                                        height: "64",
                                                        width: "64",
                                                        layout: "responsive",
                                                        priority: false
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: styles.Author,
                                                children: [
                                                    /*#__PURE__*/ _jsx(SectionParagraph, {
                                                        className: styles.Role,
                                                        children: role
                                                    }),
                                                    /*#__PURE__*/ _jsx(SectionParagraph, {
                                                        className: styles.Source,
                                                        children: source
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, quote);
                    })
                })
            }),
            viewport.desktop_small_min && /*#__PURE__*/ _jsxs("div", {
                className: styles.Arrows,
                children: [
                    /*#__PURE__*/ _jsx("button", {
                        className: styles.Arrow,
                        onClick: function() {
                            return setIndex(getPrevIndex(index));
                        },
                        "aria-label": "Go to previous testimonial",
                        children: /*#__PURE__*/ _jsx(FiArrowLeft, {})
                    }),
                    /*#__PURE__*/ _jsx("button", {
                        className: styles.Arrow,
                        onClick: function() {
                            return setIndex(getNextIndex(index));
                        },
                        "aria-label": "Go to next testimonial",
                        children: /*#__PURE__*/ _jsx(FiArrowRight, {})
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Section/SectionTitle.jsx



var SectionTitle = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
        className: (0,clsx_m/* default */.Z)((Section_module_default()).SectionTitle),
        children: children
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Section/SectionBigNumber.jsx



var SectionBigNumber = function(param) {
    var icon = param.icon, _iconColor = param.iconColor, iconColor = _iconColor === void 0 ? "teal-400" : _iconColor, number = param.number, prefix = param.prefix, abbreviation = param.abbreviation, subtitle = param.subtitle, description = param.description, _background = param.background, background = _background === void 0 ? "blue-1000" : _background, _svg = param.svg, svg = _svg === void 0 ? "" : _svg;
    var backgroundClassName = background === null || background === void 0 ? void 0 : background.replace(/-/g, "_").toLowerCase();
    var iconColorClassName = iconColor === null || iconColor === void 0 ? void 0 : iconColor.replace(/-/g, "_").toLowerCase();
    var iconToShow = icon ? typeof icon === "function" ? icon() : typeof icon === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: icon,
        alt: ""
    }) : null : typeof icon === "object" ? icon : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
        className: (0,clsx_m/* default */.Z)((Section_module_default()).SectionBigNumber, (Section_module_default())[backgroundClassName]),
        children: [
            iconToShow && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)((Section_module_default()).SectionBigNumberIcon, (Section_module_default())[iconColorClassName]),
                children: iconToShow
            }),
            svg && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)((Section_module_default()).SectionBigNumberIcon, (Section_module_default())[iconColorClassName]),
                children: svg
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Section_module_default()).SectionBigNumberTop,
                children: number && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Section_module_default()).SectionBigNumberNumber,
                    children: [
                        prefix && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (Section_module_default()).SectionBigNumberAbbr,
                            children: prefix
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: number
                        }),
                        abbreviation && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (Section_module_default()).SectionBigNumberAbbr,
                            children: abbreviation
                        })
                    ]
                })
            }),
            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Section_module_default()).SectionBigNumberSubTitle,
                children: subtitle
            }),
            description && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Section_module_default()).SectionBigNumberDescription,
                children: description
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Section/SectionWebinarThumbnails.jsx







var SectionWebinarThumbnails = function(param) {
    var _type = param.type, type = _type === void 0 ? "webinar" : _type, webinars = param.webinars, _defaultPageSize = param.defaultPageSize, defaultPageSize = _defaultPageSize === void 0 ? 3 : _defaultPageSize;
    var ref = useState([]), thumbs = ref[0], setThumbs = ref[1];
    useEffect(function() {
        if (!webinars) {
            butter.page.retrieve("*", "webinars").then(function(response) {
                var data = response.data.data.fields.webinars;
                data = data.sort(function(a, b) {
                    var dateA = new Date(a.date);
                    var dateB = new Date(b.date);
                    if (dateA < dateB) return 1;
                    if (dateA > dateB) return -1;
                    return 0;
                }).filter(function(a) {
                    return new Date(a.date) < new Date();
                }).slice(1, 1 + defaultPageSize);
                setThumbs(data);
            });
        }
    }, []);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.SectionWebinarThumbnails,
        children: thumbs === null || thumbs === void 0 ? void 0 : thumbs.map(function(param) {
            var title = param.title, video_actual = param.video_actual, date = param.date;
            return /*#__PURE__*/ _jsx(ResourceCard, {
                type: type,
                href: "".concat(linksConstants.WEBINARS_VIDEO_SLUGIFIED.split("/:")[0], "/").concat(video_actual.split("/").reverse()[0]),
                title: title,
                summary: format(new Date(date), "LLLL dd, yyyy")
            }, title);
        })
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Section/index.jsx


















/***/ }),

/***/ 55894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var buttercms__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46676);
/* harmony import */ var buttercms__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(buttercms__WEBPACK_IMPORTED_MODULE_0__);

function shouldRetry(config) {
    config["__custom_retry_handling__"] = config["__custom_retry_handling__"] || {
        retries: 0
    };
    if (config["__custom_retry_handling__"].retries < 3) {
        config["__custom_retry_handling__"].retries += 1;
        return true;
    } else {
        return false;
    }
}
// stolen from: https://github.com/softonic/axios-retry/blob/00439f4a9bde3cfe5f9c6f69b22af2b941d7c38e/es/index.mjs#L109
// and from: https://github.com/softonic/axios-retry/blob/00439f4a9bde3cfe5f9c6f69b22af2b941d7c38e/es/index.mjs#L234
function fixConfig(axios, config) {
    if (axios.defaults.agent === config.agent) {
        delete config.agent;
    }
    if (axios.defaults.httpAgent === config.httpAgent) {
        delete config.httpAgent;
    }
    if (axios.defaults.httpsAgent === config.httpsAgent) {
        delete config.httpsAgent;
    }
    config.transformRequest = [
        function(data) {
            return data;
        }
    ];
}
function axiosHook(axios) {
    axios.interceptors.response.use(function(response) {
        return response;
    }, function(error) {
        var config = error.config;
        if (!config) {
            var ref;
            // idk what would cause this to go missing, but they handle it so we should, too
            // ref: https://github.com/softonic/axios-retry/blob/00439f4a9bde3cfe5f9c6f69b22af2b941d7c38e/es/index.mjs#L207-L209
            console.info("error from buttercms: ".concat(error, " (").concat((ref = error.config) === null || ref === void 0 ? void 0 : ref.url, ")"));
            return Promise.reject(error);
        }
        if (shouldRetry(config)) {
            var ref1;
            fixConfig(axios, config);
            console.info("error from buttercms: ".concat(error, " (").concat((ref1 = error.config) === null || ref1 === void 0 ? void 0 : ref1.url, "). retrying..."));
            return axios(config);
        } else {
            var ref2;
            console.info("error from buttercms: ".concat(error, " (").concat((ref2 = error.config) === null || ref2 === void 0 ? void 0 : ref2.url, ")"));
            return Promise.reject(error);
        }
    });
}
var butter = buttercms__WEBPACK_IMPORTED_MODULE_0___default()("db35569d3bb3739cf02d32a74a1b5f6dc6243d57", false, 12000, axiosHook);
/* harmony default export */ __webpack_exports__["Z"] = (butter);


/***/ }),

/***/ 72573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ useViewport; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/platform/utils/useMediaQuery.js

/**
 * This hook is a kind of React wrapper over `window.matchMedia` functionality. It receives media
 * query as a parameter and determines if the document matches that query. It also monitors changes
 * in document so it will change the returned value if needed.
 * @param query
 * @returns {boolean}
 */ function useMediaQuery(query) {
    var ref = (0,react.useState)(false), matches = ref[0], setMatches = ref[1];
    (0,react.useEffect)(function() {
        var media = window.matchMedia(query);
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        var listener = function() {
            setMatches(media.matches);
        };
        // older browsers don't have support for`addEventListener` in matchMedia and have to use
        // older "addListener" function
        if (media && media.addEventListener) {
            media.addEventListener("change", listener);
        } else {
            media.addListener(listener);
        }
        return function() {
            if (media && media.removeEventListener) {
                media.removeEventListener("change", listener);
            } else {
                media.removeListener(listener);
            }
        };
    }, [
        matches,
        query
    ]);
    return matches;
}

;// CONCATENATED MODULE: ./src/platform/utils/useViewport.js

var useViewport = function() {
    var desktop_small_min = useMediaQuery("(min-width: 64.001rem)");
    var desktop_min = useMediaQuery("(min-width: 70.001rem)");
    var desktop = useMediaQuery("(max-width: 90rem)");
    var desktop_small = useMediaQuery("(max-width: 70rem)");
    var tablet_landscape = useMediaQuery("(max-width: 64rem)");
    var tablet = useMediaQuery("(max-width: 48rem)");
    var mobile = useMediaQuery("(max-width: 30rem)");
    return {
        desktop_small_min: desktop_small_min,
        desktop_min: desktop_min,
        desktop: desktop,
        desktop_small: desktop_small,
        tablet_landscape: tablet_landscape,
        tablet: tablet,
        mobile: mobile
    };
};


/***/ }),

/***/ 62225:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"CtaLinkButtonContainer":"Button_CtaLinkButtonContainer__4jIer","Button":"Button_Button__K4TEY","LinkButton":"Button_LinkButton__qZGHC","Size_lg":"Button_Size_lg__5Smhm","Size_md":"Button_Size_md__jnXlx","Size_sm":"Button_Size_sm__Fxv8j","Inverted":"Button_Inverted__v_w9x","Text":"Button_Text__GxyrI","BookDemoButton":"Button_BookDemoButton__npFzI","Secondary":"Button_Secondary__66O00","Secondary_alt":"Button_Secondary_alt__wygzW","AutoWidth":"Button_AutoWidth__L1orr","Disabled":"Button_Disabled__t8349"};

/***/ }),

/***/ 51979:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"HeroContainer":"Hero_HeroContainer__Ub8up","section-layout":"Hero_section-layout__NukfT","HeroColWrapper":"Hero_HeroColWrapper__K8lwy","HeroCol":"Hero_HeroCol__H1sR4","Hero":"Hero_Hero__IzYn4","violet_1000":"Hero_violet_1000__nDw2_","violet_900":"Hero_violet_900__8kNMq","violet_800":"Hero_violet_800__9Ov_m","primary_900":"Hero_primary_900__i2CNY","blue_700":"Hero_blue_700__CUShy","primary_700":"Hero_primary_700__nIDWO","RemoveTopPadding":"Hero_RemoveTopPadding__CN4BG","RemoveBottomPadding":"Hero_RemoveBottomPadding__qbhGD","DoubledPadding":"Hero_DoubledPadding__vFU_V","TypeTwoCol":"Hero_TypeTwoCol__3V9GD","HeroTitle":"Hero_HeroTitle__exoSJ","HeroSubtitle":"Hero_HeroSubtitle__SrMnN","HeroImage":"Hero_HeroImage__ArVxK","TypeTwoColForm":"Hero_TypeTwoColForm__RY5aO","TypeTwoColText":"Hero_TypeTwoColText__oP4n5","NoMarginBottom":"Hero_NoMarginBottom__ooVrG","HeroParagraph":"Hero_HeroParagraph__z_BcO","HeroSubheading":"Hero_HeroSubheading__1VTdO","HeroImageWrapper":"Hero_HeroImageWrapper__AFh54","HeroBadges":"Hero_HeroBadges__bQ0PL","HeroVideo":"Hero_HeroVideo__VmANL","HeroVideoPlaceholderImage":"Hero_HeroVideoPlaceholderImage__bJpyU","HeroVideoPlaceholder":"Hero_HeroVideoPlaceholder__GPzR6","HeroVideoPlayer":"Hero_HeroVideoPlayer__nOxnQ","HeroStars":"Hero_HeroStars__QVgWJ","HeroStars1":"Hero_HeroStars1__qW2cZ","animateStar":"Hero_animateStar__fas14","HeroStars2":"Hero_HeroStars2__TpJRT"};

/***/ }),

/***/ 81144:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SectionContainer":"Section_SectionContainer__llzda","Section":"Section_Section__WJRYa","section-layout":"Section_section-layout__mgblg","black":"Section_black__oUaW0","white":"Section_white__dJKjQ","coolgray_50":"Section_coolgray_50__yyLoc","coolgray_100":"Section_coolgray_100__Ziy_s","coolgray_200":"Section_coolgray_200__77R1B","coolgray_300":"Section_coolgray_300__Ibew6","coolgray_400":"Section_coolgray_400__MPgaI","coolgray_500":"Section_coolgray_500__mseud","coolgray_600":"Section_coolgray_600__IooUo","coolgray_700":"Section_coolgray_700__TDKm7","coolgray_800":"Section_coolgray_800__uMWHg","coolgray_900":"Section_coolgray_900__gxLkE","teal_50":"Section_teal_50__8B1vv","teal_100":"Section_teal_100__e9fJ5","teal_200":"Section_teal_200__frzAP","teal_300":"Section_teal_300__w1kmZ","teal_400":"Section_teal_400__MFhit","teal_500":"Section_teal_500__kYmgv","teal_600":"Section_teal_600__vM375","teal_700":"Section_teal_700___q9nQ","teal_800":"Section_teal_800__lxgzP","teal_900":"Section_teal_900__AAZqd","teal_1000":"Section_teal_1000__ggnfr","blue_25":"Section_blue_25__1grOj","blue_50":"Section_blue_50__8FiuR","blue_100":"Section_blue_100__brzFm","blue_200":"Section_blue_200__uT5vQ","blue_300":"Section_blue_300__9NPJY","blue_400":"Section_blue_400__lvJTb","blue_500":"Section_blue_500__ESUaR","blue_600":"Section_blue_600__TYbDF","blue_700":"Section_blue_700__NFsZW","blue_800":"Section_blue_800__zQxiC","blue_900":"Section_blue_900__AMtCO","blue_1000":"Section_blue_1000__lLX0_","pink_50":"Section_pink_50__nAtP3","pink_100":"Section_pink_100__hr9h3","pink_200":"Section_pink_200__jvZ44","pink_300":"Section_pink_300__4w7Fj","pink_400":"Section_pink_400__Z86Iv","pink_500":"Section_pink_500__MIYG2","pink_600":"Section_pink_600__Hbwap","pink_700":"Section_pink_700__MWKVP","pink_800":"Section_pink_800__vpjFf","pink_900":"Section_pink_900__UjsQG","pink_1000":"Section_pink_1000__ByCxV","violet_50":"Section_violet_50__Xqvwy","violet_100":"Section_violet_100__eSe8c","violet_200":"Section_violet_200__xAUzC","violet_300":"Section_violet_300__Y2BnZ","violet_400":"Section_violet_400__8Fk4s","violet_500":"Section_violet_500__97srX","violet_600":"Section_violet_600__UE6av","violet_700":"Section_violet_700__MggX1","violet_800":"Section_violet_800__oQRnV","violet_900":"Section_violet_900__PGQS1","violet_1000":"Section_violet_1000__4kdpQ","SectionTitle":"Section_SectionTitle__DdIHA","SectionHeading":"Section_SectionHeading__wFN48","SectionSubtitle":"Section_SectionSubtitle__8wqxE","SectionParagraph":"Section_SectionParagraph__8qSRZ","blue_25_to_coolgray_200":"Section_blue_25_to_coolgray_200__I1xgY","blue_100_to_coolgray_100":"Section_blue_100_to_coolgray_100__2qbb7","blue_25_to_blue_200":"Section_blue_25_to_blue_200__hrJgu","coolgray_50_to_blue_200":"Section_coolgray_50_to_blue_200__nvAcf","blue_25_to_white":"Section_blue_25_to_white__LIiNE","coolgray_50_to_coolgray_100":"Section_coolgray_50_to_coolgray_100__Ac5Hv","coolgray_100_to_coolgray_200":"Section_coolgray_100_to_coolgray_200__YGewF","white_to_coolgray_100":"Section_white_to_coolgray_100__vEMM_","white_to_blue_200":"Section_white_to_blue_200__z7Yp1","DoubledPadding":"Section_DoubledPadding__oAc8r","RemoveTopPadding":"Section_RemoveTopPadding__8K12Q","RemoveBottomPadding":"Section_RemoveBottomPadding__SVD49","TypeNoPadding":"Section_TypeNoPadding__JWEMn","TypeOneCol":"Section_TypeOneCol__FdM4F","SectionColWrapper":"Section_SectionColWrapper__h6zt3","SectionCol":"Section_SectionCol__bScKC","TypeTwoCol":"Section_TypeTwoCol__CJS5G","SectionImage":"Section_SectionImage__RlCch","OverrideReversal":"Section_OverrideReversal__b3wOe","Reverse":"Section_Reverse__eLlE6","ReverseMobile":"Section_ReverseMobile__PZ633","TypeThreeCol":"Section_TypeThreeCol__aAzks","ColWidthsEqual":"Section_ColWidthsEqual__1fOdi","OverlayHero":"Section_OverlayHero__VKcej","SectionMasthead":"Section_SectionMasthead__hLLri","h2":"Section_h2__W8q7_","h3":"Section_h3__oRq9c","h4":"Section_h4__CmWlp","SectionSubheading":"Section_SectionSubheading__V2lO8","SectionList":"Section_SectionList__YcBFH","SectionListCard":"Section_SectionListCard__rRodq","SectionListSmall":"Section_SectionListSmall__fo1bP","SectionListItem":"Section_SectionListItem__lkMMk","SectionListItemContent":"Section_SectionListItemContent__Io0NJ","SectionListItemIcon":"Section_SectionListItemIcon__TDSsG","SectionButtonGridWrapper":"Section_SectionButtonGridWrapper__PHHvM","SectionDataGridButtonWrapper":"Section_SectionDataGridButtonWrapper__AERlT","SectionButtonGrid":"Section_SectionButtonGrid__Lxa6e","GridSizeTwo":"Section_GridSizeTwo__KDYJh","GridSizeFour":"Section_GridSizeFour__g77Bb","SectionButtonGridButton":"Section_SectionButtonGridButton__oLm0C","SectionButtonGridButtonLabel":"Section_SectionButtonGridButtonLabel__XFTmy","SectionButtonGridButtonIcon":"Section_SectionButtonGridButtonIcon__VBJZ9","DataProviders":"Section_DataProviders__sIQNG","Attom":"Section_Attom__foNdF","Powerlytics":"Section_Powerlytics__bVpNh","Seon":"Section_Seon__qm1GH","Equifax":"Section_Equifax__MXCqS","Ekata":"Section_Ekata___csj5","Experian":"Section_Experian___iI9T","Transunion":"Section_Transunion__EgXd3","HouseCanary":"Section_HouseCanary__VYuZ2","Telesign":"Section_Telesign__dkZcV","Pipl":"Section_Pipl__ZOBYk","UseCases":"Section_UseCases__RR_gj","SectionButtonGridContent":"Section_SectionButtonGridContent__2xOk_","SectionCallout":"Section_SectionCallout__3FDOB","SectionBlogThumbnails":"Section_SectionBlogThumbnails__7ppnB","SectionBlogThumbnailsAlternate":"Section_SectionBlogThumbnailsAlternate__b4OKv","SectionWebinarThumbnails":"Section_SectionWebinarThumbnails__UlLb7","SectionBigNumber":"Section_SectionBigNumber__WkvK3","SectionBigNumberIcon":"Section_SectionBigNumberIcon__QDtew","SectionBigNumberNumber":"Section_SectionBigNumberNumber__e1iE4","SectionBigNumberAbbr":"Section_SectionBigNumberAbbr__4whJp","SectionBigNumberSubTitle":"Section_SectionBigNumberSubTitle__CFVZo","SectionBigNumberDescription":"Section_SectionBigNumberDescription__zncC6","Responsive":"Section_Responsive__v9ZrS"};

/***/ })

}]);